import { Injectable } from '@angular/core';
import { PersonaPadlockError } from '@talisdev/persona-padlock';
import * as URI from 'urijs';

import { AuthorizationFailedException } from '®shared/auth';
import { ErrorReportingService } from '®shared/reporting/error-reporting.service';

interface ErrorDetails {
  title: string;
  message: string;
  code: '401' | '403' | '500';
}

@Injectable()
export class AuthErrorService {
  constructor(private errorReportingService: ErrorReportingService) {}

  public buildUserAuthErrorUrl(error: unknown): string {
    const { title, message, code } = this.getErrorDetails(error);

    const errorUri = new URI('/3/pkce/error.html');
    errorUri.addQuery('title', title);
    errorUri.addQuery('detail', message);
    errorUri.addQuery('code', code);

    return errorUri.toString();
  }

  private getErrorDetails(error: unknown): ErrorDetails {
    if (error instanceof PersonaPadlockError) {
      this.errorReportingService.reportToInstana(error);

      return {
        title: $localize`:@@authErrorService-loginErrorTitle:Login error`,
        message: $localize`:@@authErrorService-loginErrorMessage:An error occurred during login`,
        code: '401',
      };
    } else if (error instanceof AuthorizationFailedException) {
      return {
        title: $localize`:@@authErrorService-authorizationErrorTitle:Authorization error`,
        message: $localize`:@@authErrorService-authorizationErrorMessage:You do not have the required permissions to access this page`,
        code: '403',
      };
    } else {
      this.errorReportingService.reportToInstana(error);

      return {
        title: $localize`:@@authErrorService-unknownErrorTitle:Unknown error`,
        message: $localize`:@@authErrorService-unknownErrorMessage:An error occurred during login`,
        code: '500',
      };
    }
  }
}
